// Minimal fallback tenant definitions used when Supabase is misconfigured or unavailable.
// These are safe, non-sensitive UI defaults to keep tenant sites rendering in DEV/QA and as a last-resort in PROD.

export type FallbackTenant = {
  id: string;
  name: string;
  subdomain: string;
  logo_url?: string;
  color_scheme_json?: Record<string, string> | null;
  banner_config_json?: Record<string, any> | null;
  // additional optional fields the UI may read safely
};

const RED = "#da1884"; // brand red used for Start Matrix and CTAs

const FALLBACKS: Record<string, FallbackTenant> = {
  virtuzone: {
    id: "fb-virtuzone",
    name: "Virtuzone",
    subdomain: "virtuzone",
    // logo_url intentionally omitted to fall back to default YC logo
    color_scheme_json: {
      primary: RED,
      secondary: "#111827",
      accent: RED,
      background: "#ffffff",
      text: "#111827",
      // custom keys consumed in UI styles
      startMatrixButtonColor: RED,
    },
    banner_config_json: {
      backgroundColor: "#f2f3ee",
      bottomBannerBackgroundColor: "#f2f3ee",
      bottomBannerTextColor: "#111827",
      textColor: "#111827",
      backgroundImage: null,
    },
  },
  audits: {
    id: "fb-audits",
    name: "Audits",
    subdomain: "audits",
    color_scheme_json: {
      primary: "#111827",
      secondary: "#111827",
      accent: "#D9FF3F",
      background: "#ffffff",
      text: "#111827",
      startMatrixButtonColor: "#111827",
    },
    banner_config_json: {
      backgroundColor: "#ffffff",
      textColor: "#111827",
    },
  },
  dubaicommercity: {
    id: "fb-dcc",
    name: "Dubai CommerCity",
    subdomain: "dubaicommercity",
    color_scheme_json: {
      primary: "#4B1F5E",
      secondary: "#4B1F5E",
      accent: "#4B1F5E",
      background: "#ffffff",
      text: "#111827",
      startMatrixButtonColor: "#4B1F5E",
    },
    banner_config_json: {
      backgroundColor: "#ffffff",
      textColor: "#111827",
    },
  },
  "incorpify-ai": {
    id: "fb-incorpify",
    name: "Incorpify",
    subdomain: "incorpify-ai",
    color_scheme_json: {
      primary: "#111827",
      secondary: "#111827",
      accent: "#111827",
      background: "#ffffff",
      text: "#111827",
      startMatrixButtonColor: "#111827",
    },
    banner_config_json: {
      backgroundColor: "#ffffff",
      textColor: "#111827",
    },
  },
};

export function getFallbackTenant(subdomain: string): FallbackTenant | null {
  const key = (subdomain || "").toLowerCase();
  return FALLBACKS[key] || null;
}

